import React from "react";

import {
  ContentContainer,
  Title,
  TitleContainer,
  CloseContainer,
  Column,
  Button,
  Input,
} from "../InviteUserModal/InviteUserModal.style";

import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { useTranslation } from "react-i18next";
import Modal2 from "../Modal/Modal2";

const ChargeWalletModal = ({ onClick, onChange, value, open, close }) => {
  const { t } = useTranslation();

  return (
    <Modal2
      border={"2px solid #484888"}
      bg={"linear-gradient(360deg, #7f7fac -100%, #484888 100%)"}
      onClose={close}
      open={open}
      height={"fit-content"}
      width={"fit-content"}
    >
      <ContentContainer>
        <CloseContainer onClick={close}>
          <Close className="close" fill="#fff" />
        </CloseContainer>

        <Column>
          <TitleContainer>
            <Title>{t("enter-the-amount")}</Title>
          </TitleContainer>
          <div style={{ display: "flex", flexDirection: "column", gap: 40 }}>
            <Input type="number" value={value} onChange={onChange} min={1} />

            <Button onClick={onClick}>{t("confirm")}</Button>
          </div>
        </Column>
      </ContentContainer>
    </Modal2>
  );
};

export default ChargeWalletModal;
